// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13aoC","title":"Info_title__1-s3T","selects":"Info_selects__1B4Ic","requiredAsterisk":"Info_requiredAsterisk__2I6Oe"};